import Recupera from '../../spa/recuperaUsuario/RecuperaUsuario';

export default {
    path: 'Recupera',
    name: 'Recupera',
    component: Recupera,
};


// WEBPACK FOOTER //
// ./src/config/router/recuperaUsuario.js